import React, {Component} from 'react';
import {Link} from 'react-router';
import Translate from '../layout/Translate';
import moment from 'moment';
import ClickOutside from 'react-click-outside';

export default class Review extends Component {


    componentWillMount() {



    }


    componentWillUpdate() {



    }

    openReview(review, i) {
        this.props.actions.openReview(i);
    }

    openReviewAnswer(review, i) {
        this.props.actions.openReviewAnswer(i);
    }


    toggleReviewRate(review, i) {
        this.props.actions.toggleReviewRate(i);
    }

    closeReviewRate(review, i) {
        if (review.openRate) {
            this.props.actions.toggleReviewRate(i);
        }
    }
    selectTour(tour) {
        console.log(this.props);
        this.props.actions.selectTour(tour);
        this.props.actions.fetchPostsIfNeeded(1, tour.id);
        this.props.actions.fetchReviews(tour.id);
    }

    render() {
        let { review, i } = this.props;




        
        return (

            <div className={"review "}>
                <div className="review__header">
                    <div className="review__rating" onClick={this.toggleReviewRate.bind(this, review, i)}>{parseFloat(review.rate_total?review.rate_total:0).toLocaleString('ru-RU', {minimumFractionDigits: 2})}</div>

                    <ClickOutside onClickOutside={this.closeReviewRate.bind(this, review, i)}>
                        <div className={"review__popup " + (review.openRate?"review__popup_open":"")}>
                                <div className="review__close" onClick={this.toggleReviewRate.bind(this, review, i)}></div>
                                <div className="review__detailed review__detailed_total">
                                    <div className="review__rating review__rating_detailed" onClick={this.toggleReviewRate.bind(this, review, i)}>
                                        {parseFloat(review.rate_total?review.rate_total:'—').toLocaleString('ru-RU', {minimumFractionDigits: 2})}
                                    </div><Translate slug="review__rate_total" />
                                </div>
                                <div className="review__detailed">
                                    <div className="review__rating review__rating_detailed">
                                        {(review.rate_office?review.rate_office:'—').toLocaleString('ru-RU', {minimumFractionDigits: 2})}
                                    </div><Translate slug="review__rate_office" />
                                </div>
                                <div className="review__detailed">
                                    <div className="review__rating review__rating_detailed">
                                        {(review.rate_accomodation?review.rate_accomodation:'—').toLocaleString('ru-RU', {minimumFractionDigits: 2})}
                                    </div><Translate slug="review__rate_accomodation" />
                                </div>
                                <div className="review__detailed">
                                    <div className="review__rating review__rating_detailed">
                                        {(review.rate_transport?review.rate_transport:'—').toLocaleString('ru-RU', {minimumFractionDigits: 2})}
                                    </div><Translate slug="review__rate_transport" />
                                </div>
                                <div className="review__detailed">
                                    <div className="review__rating review__rating_detailed">
                                        {(review.rate_meals?review.rate_meals:'—').toLocaleString('ru-RU', {minimumFractionDigits: 2})}
                                    </div><Translate slug="review__rate_meals" />
                                </div>
                                <div className="review__detailed">
                                    <div className="review__rating review__rating_detailed">
                                        {(review.rate_guides?review.rate_guides:'—').toLocaleString('ru-RU', {minimumFractionDigits: 2})}
                                    </div><Translate slug="review__rate_guides" />
                                </div>
                                <div className="review__detailed">
                                    <div className="review__rating review__rating_detailed">
                                        {(review.rate_recreation?review.rate_recreation:'—').toLocaleString('ru-RU', {minimumFractionDigits: 2})}
                                    </div><Translate slug="review__rate_recreation" />
                                </div>
                        </div>
                    </ClickOutside>

                    <div className="review__info">
                        {review.first_name &&
                            <div className="review__name">{review.first_name}</div>
                        }
                        <div className={"review__flag"}>
                            <img src={"/static/flags/flag_" + review.country + ".gif"} />
                        </div>
                        <div className="review__params">
                            <div className="review__param"><Translate slug="review__from" /> {review.formated_start_date} <Translate slug="review__to" /> {review.formated_end_date}</div>
                            {review.destinations && !!review.destinations.length &&
                            <div className="review__param">
                                <Translate slug="review__region" />: {review.destinations.map((destination, i)=><span><Link to={"/destinations/" + destination.slug}>{destination.title}</Link>{review.destinations.length > i+1 && ', '}</span>
                            )}
                            </div>
                            }

                            {review.programs && !!review.programs.length &&
                            <div className="review__param review__param_inline">
                                <Translate slug="review__tours" />:&nbsp;
                                {review.programs.map((tour, i)=>
                                        <span>
                                    {!tour.is_archived &&
                                        <Link className="review__tour"
                                            to={"/tours/" + tour.id} onClick={this.selectTour.bind(this, tour)}>{tour.title}
                                        </Link>
                                    }
                                    {!!tour.is_archived &&
                                        <Link className="review__tour"
                                            to={"/tours/archive/" + tour.id} onClick={this.selectTour.bind(this, tour)}>{tour.title}
                                        </Link>
                                    }
                                    {review.programs.length > i+1 && ', '}
                                </span>
                                )}
                            </div>
                            }

                            {(review.surmesur && review.surmesur.surmesur_name) &&

                                <div className="review__param review__param_inline">
                                    <Translate slug="review__custom" />:&nbsp;
                                    <span>{review.surmesur.surmesur_name}</span>
                                </div>
                            }

                                <div className="review__param">
                                    <Translate slug="review__go" />&nbsp;
                                    {review.is_comeback == 1 &&
                                        <Translate slug="review__yes" />
                                    }
                                    {review.is_comeback == 0 &&
                                        <Translate slug="review__no" />
                                    }
                                    {!review.is_comeback != 0 && !review.is_comeback != 1 &&
                                        "-"
                                    }
                                </div>
                        </div>
                    </div>
                </div>
                <div className="review__text">
                    {!review.open &&
                    <span>
                        {review.preview}
                    </span>
                    }
                    {review.open &&
                    <span>
                            {review.comment}
                        </span>
                    }
                    {!review.comment &&
                        <div className="review__without-comment">
                            <Translate slug="review__without-comment" />
                        </div>
                    }
                    {review.comment && review.comment.length > review.preview.length && !review.open &&
                    <div className="review__more" onClick={this.openReview.bind(this, review, i)}>
                        &nbsp;&nbsp;<Translate slug="review__more" />
                    </div>
                    }
                    {review.answer &&
                        <div className="review__answer">
                            <div className="review__baikalnature"><Translate slug="review__answer" /></div>
                            {!review.openAnswer && review.previewAnswer}
                            {!!review.openAnswer && review.answer}

                            {(review.answer && (review.answer.length > review.previewAnswer.length) && !review.openAnswer) &&
                            <div className="review__more" onClick={this.openReviewAnswer.bind(this, review, i)}>
                                &nbsp;&nbsp;<Translate slug="review__more" />
                            </div>
                            }
                        </div>
                    }

                </div>

            </div>


        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/tour/Review.js